module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StartPage/caution-64a718a4bfb03b4b48957c0d304234c0.svg";